import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import About from "./pages/about";
import Contact from "./pages/contact";
import Deals from "./pages/deals";
import Login from "./pages/login";
import Signup from "./pages/signup";
import YachtDetails from "./pages/yachtdetails";

// ✅ New Imports
import Addons from "./pages/addons";
import Cart from "./pages/cart";
import ConfirmBooking from "./pages/confirmbooking";
import Privacy from "./pages/Privacy";
import Refund from "./pages/refund";
import Terms from "./pages/terms";
import ThankYou from "./pages/thankyou";
import Yachts from "./pages/yachts";
import NotFound from "./pages/NotFound";
import Profile from "./pages/profile";
import OrderDetails from "./pages/OrderDetails";
import BirthdayLanding from "./pages/birthdayLanding";
import CorporateLanding from "./pages/corporateLanding";
import CorporateEventsLanding from "./pages/corporateEventsLanding";
import FamilyPartyLanding from "./pages/familyPartyLanding";
import PreWeddingLanding from "./pages/preWeddingLanding";
import AlibaugLanding from "./pages/alibaugLanding";
import PrivateYacht from "./pages/PrivateYacht";
import PartyYachtMumbai from "./pages/partyyachtmumbai";
import Speedboattransfer from "./pages/speedboattransfer";
import CorporateSailingEventsMumbai from "./pages/corporateSailingEventsMumbai";
import Alibaug from "./pages/Alibaug";
import CorporateEvents from "./pages/CorporateEvents";
import FamilyEvents from "./pages/FamilyEvents";
import PreWedding from "./pages/PreWedding";
import PrivateYachtCharters from "./pages/PrivateYachtCharters";
import SpeedBoat from "./pages/SpeedBoat";
import YachtParties from "./pages/yachtParties";
import Regattas from "./pages/Regattas";
import CorporateParties from "./pages/CorporateParties";
import ScrollToTopButton from "./Components/ScrollToTopButton";
import CorporateNetworking from "./pages/CorporateNetworking";
import Birthdays from "./pages/Birthdays";
import Family from "./pages/Family";
import Packages from "./pages/Packages";
import Gift from "./pages/Gift";
import Gallery from "./pages/Gallery";

import AdminLayout from "./admin/components/AdminLayout";
import AdminDashboard from "./admin/pages/AdminDashboard";
import SignatureExperience from "./admin/pages/SignatureExperience";
import AdminLogin from "./admin/pages/AdminLogin";
import ProtectedRoute from "./admin/components/ProtectedRoute";
import MostLovedExperiences from "./admin/pages/MostLovedExperiences";
import TestimonialsVideos from "./admin/pages/TestimonialsVideos";
import PackagesCms from "./admin/pages/Packages";
import BrowsePackages from "./admin/pages/BrowsePackages";
import Faqs from "./admin/pages/Faqs";
import Experiences from "./admin/pages/Experiences";
import PrivateYachtCms from "./admin/pages/PrivateYachtCms";
import YachtPartiesCms from "./admin/pages/YachtPartiesCms";
import SpeedBoatCms from "./admin/pages/SpeedBoatCms";
import SpeedBoatRates from "./admin/pages/SpeedBoatRates";
import AddonsCms from "./admin/pages/AddonsCms";
import Enquiries from "./admin/pages/Enquiries";
import Newsletter from "./admin/pages/Newsletter";
import TimeSlots from "./admin/pages/TimeSlots";
import YachtDetailsCms from "./admin/pages/YachtDetails";
import Signups from "./admin/pages/Signups";
import ConfirmedBookings from "./admin/pages/ConfirmedBookings";
import ScrollToTop from "./Components/ScrollToTop";

function App() {
  return (
    <BrowserRouter>
    <ScrollToTop />
      <Routes>
        {/* Main Pages */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/deals" element={<Deals />} />
        <Route path="/yachts" element={<Yachts />} />

        {/* Auth */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />

        {/* Booking Flow */}
        <Route path="/cart" element={<Cart />} />
        <Route path="/addons" element={<Addons />} />
        <Route path="/confirmbooking" element={<ConfirmBooking />} />
        <Route path="/thankyou/:id" element={<ThankYou />} />

        {/* Legal Pages */}
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/refund" element={<Refund />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/OrderDetails" element={<OrderDetails />} />
        <Route path="/BirthdayLanding" element={<BirthdayLanding />} />
        <Route path="/CorporateLanding" element={<CorporateLanding />} />
        <Route
          path="/CorporateEventsLanding"
          element={<CorporateEventsLanding />}
        />
        <Route path="/FamilyPartyLanding" element={<FamilyPartyLanding />} />
        <Route path="/PreWeddingLanding" element={<PreWeddingLanding />} />
        <Route path="/AlibaugLanding" element={<AlibaugLanding />} />
        <Route
          path="/private-yacht-charter-mumbai-goa"
          element={<PrivateYacht />}
        />
        <Route path="/party-yacht-mumbai-goa" element={<PartyYachtMumbai />} />
        <Route
          path="/speedboat-transfer-mumbai"
          element={<Speedboattransfer />}
        />
        <Route
          path="/corporate-sailing-events-mumbai"
          element={<CorporateSailingEventsMumbai />}
        />
        <Route path="/Alibaug" element={<Alibaug />} />
        <Route path="/CorporateEvents" element={<CorporateEvents />} />
        <Route path="/FamilyEvents" element={<FamilyEvents />} />
        <Route
          path="/pre-wedding-yacht-photoshoot-mumbai"
          element={<PreWedding />}
        />
        <Route path="/SpeedBoat" element={<SpeedBoat />} />
        <Route path="/yacht-party-mumbai" element={<YachtParties />} />
        <Route
          path="/corporate-sailing-regatta-mumbai"
          element={<Regattas />}
        />
        <Route
          path="/corporate-party-awards-yacht-mumbai"
          element={<CorporateParties />}
        />
        <Route
          path="/corporate-events-networking-yacht-mumbai"
          element={<CorporateNetworking />}
        />
        <Route
          path="/birthday-anniversary-yacht-celebration-mumbai"
          element={<Birthdays />}
        />
        <Route path="/family-private-yacht-party-mumbai" element={<Family />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/gift" element={<Gift />} />
        <Route path="/gallery" element={<Gallery />} />

        <Route path="/yachtdetails/:slug" element={<YachtDetails />} />

        <Route
  path="/admin/login"
  element={<AdminLogin />}
/>


<Route
  element={<ProtectedRoute />}
>

  <Route
    path="/admin"
    element={<AdminLayout />}
  >

    <Route
      index
      element={<AdminDashboard />}
    />

    <Route
      path="signature-experience"
      element={<SignatureExperience />}
    />

    <Route
  path="most-loved-experiences"
  element={
    <MostLovedExperiences />
  }
/>

    <Route
      path="testimonials"
      element={<TestimonialsVideos />}
    />

    <Route
      path="packages"
      element={<PackagesCms />}
    />

    <Route
      path="browse-packages"
      element={<BrowsePackages />}
    />

    <Route
      path="faqs"
      element={<Faqs />}
    />

    <Route
      path="experiences"
      element={<Experiences />}
    />

    <Route
      path="private-yacht"
      element={<PrivateYachtCms />}
    />

    <Route
      path="yacht-parties"
      element={<YachtPartiesCms />}
    />

    <Route
      path="speed-boats"
      element={<SpeedBoatCms />}
    />

    <Route
      path="enquiries"
      element={<Enquiries />}
    />

    <Route
      path="newsletter"
      element={<Newsletter />}
    />

    <Route
      path="time-slots"
      element={<TimeSlots />}
    />

    <Route
      path="yacht-details"
      element={<YachtDetailsCms />}
    />

    <Route
      path="speedboat-times"
      element={<SpeedBoatRates />}
    />

    <Route
      path="addons"
      element={<AddonsCms />}
    />

    <Route
      path="signups"
      element={<Signups />}
    />

    <Route
      path="confirmed-bookings"
      element={<ConfirmedBookings />}
    />

  </Route>

</Route>

        <Route path="*" element={<NotFound />} />
      </Routes>

      <ScrollToTopButton />
    </BrowserRouter>
  );
}

export default App;
